module.exports = __webpack_public_path__ + "img/meme_16.2e78694e.jpg";